import { useDispatch, useSelector } from 'react-redux';
import { updateActiveFormGeneralInformation, updateActiveFormInvestigationType, updateActiveFormClientInfo, 
    updateActiveFormBackgroundScreeningDetails, updateActiveFormBackgroundScreeningSocialMedia, updateActiveFormBusinessDueDiligenceDetails,
    updateActiveFormAssetLocateType, updateActiveFormAssetLocateDetails, updateActiveFormAssetLocateRequest,
    updateActiveFormDMVDetails, updateActiveFormInsuranceClaimHistoryDetails, updateActiveFormInsuranceClaimHistorySubject,
    updateActiveFormInsuranceInvestigationBusinessDetails, updateActiveFormInsuranceInvestigationBusinessDriversDetails, updateActiveFormInsuranceInvestigationBusinessAdditionalInformation,
    updateActiveFormInsuranceInvestigationLocateDetails, updateActiveFormInsuranceInvestigationLocateDriversDetails, updateActiveFormInsuranceInvestigationLocateAdditionalInformation,
    updateActiveFormInsuranceInvestigationPersonalAutoUmbrellaDetails, updateActiveFormInsuranceInvestigationPersonalAutoUmbrellaDriversDetails,updateActiveFormInsuranceInvestigationPersonalAutoUmbrellaAdditionalInformation,
    updateActiveFormInsuranceInvestigationPersonalHomeownersRentersDetails, updateActiveFormInsuranceInvestigationPersonalHomeownersRentersAdditionalInformation,
    updateActiveFormSceneInvestigationDetails, updateActiveFormSkipTraceDetails, updateActiveFormSubpoenaProcessServingDetails, updateActiveFormSWITRSDetails, updateTrafficCollisionsReportRetrievalDetails,
    updateWitnessDefendantStatementDetails, updateWitnessDefendantStatementDefendantDetails, updateWitnessDefendantStatementWitnessDetails, updateWitnessDefendantStatementFaultInfo,
    updateActiveFormAdditionalInformation, updateSpecificOrderTypeDetailsProps } from '../reducers/active-form-slice';
import { selectOrder } from '../reducers/order-details-slice';
import { orderTypes } from './order-type-ids';


export const PrepopulateIntakeForms = () => {
    const dispatch = useDispatch();
    const order = useSelector(selectOrder);
    var clientInfo = {};

    const populateFormData = async () => {
        // Update General Information
        const caseManagerParts = order.details.managerAssigned.split(' ');
        const caseManagerFirst = caseManagerParts[0];
        const caseManagerLast = caseManagerParts.slice(1).join(' ');

        const userValues = {
            firstNameCaseManager: caseManagerFirst,
            lastNameCaseManager: caseManagerLast,
            emailPrimary: order.details.managerAssignedEmail,
            emailSecondary: order.details.managerAssignedEmail2,
            phonePrimary: order.details.managerAssignedPhone,
            phoneSecondary: order.details.managerAssignedPhone2,
        };
        const firmValues = {
            lawFirmName: order.details.lawFirm,
            address: order.details.lawFirmAddress1,
            address2: order.details.lawFirmAddress2,
            city: order.details.lawFirmCity,
            stateProvince: order.details.lawFirmState,
            zip: order.details.lawFirmZip,
            country: order.details.lawFirmCountry,
        };

        const initialValues = {
            ...userValues,
            ...firmValues,
        };
        dispatch(updateActiveFormGeneralInformation(initialValues));


        // Update Investigation Type and Client Information
        let orderTypeObject = [order.details.investigationType, order.details.investigationTypeId];
        dispatch(updateActiveFormInvestigationType(orderTypeObject));

        const caseNameParts = order.details.caseName.split(' ');
        const caseNameFirst = caseNameParts[0];
        const caseNumber = caseNameParts.length > 2 ? caseNameParts.pop() : '';
        const caseNameLast = caseNameParts.slice(1).join(' ');

        clientInfo = {
            firstNameClient: caseNameFirst || '',
            lastNameClient: caseNameLast || '',
            fileNumberClient: caseNumber || ''
        }
        dispatch(updateActiveFormClientInfo(clientInfo));

        await updateSpecificInvestigationTypeForms(order.details.investigationTypeId);
    };


    /**
     * Update specific forms based on investigation type
     */
    const updateSpecificInvestigationTypeForms = async (investigationTypeId) => {
        var specificOrderDetails = JSON.parse(order.details.specificOrderTypeDetails);

        switch (investigationTypeId) {
            case orderTypes.AL:
                populateAssetLocateForms(specificOrderDetails);
                dispatch(updateSpecificOrderTypeDetailsProps(["assetLocateDetails", "assetLocateRequest", "assetLocateType", "additionalInformation"]));
                break;
            case orderTypes.BSMS:
                populateBackgroundScreeningForms(specificOrderDetails);
                dispatch(updateSpecificOrderTypeDetailsProps(["backgroundScreeningDetails", "backgroundScreeningSocialMedia", "additionalInformation"]));
                break;
            case orderTypes.DD:
                populateBusinessDueDiligenceForms(specificOrderDetails);
                dispatch(updateSpecificOrderTypeDetailsProps(["businessDueDiligenceDetails", "additionalInformation"]));
                break;
            case orderTypes.DMV:
                populateDmvForms(specificOrderDetails);
                dispatch(updateSpecificOrderTypeDetailsProps(["dmvDetails", "additionalInformation"]));
                break;
            case orderTypes.ISO:
                populateInsuranceClaimHistoryForms(specificOrderDetails);
                dispatch(updateSpecificOrderTypeDetailsProps(["insuranceClaimHistoryDetails", "insuranceClaimHistorySubject", "additionalInformation"]));
                break;
            case orderTypes.PLB:
                populateInsuranceInvestigationBusinessForms(specificOrderDetails);
                dispatch(updateSpecificOrderTypeDetailsProps(["insuranceInvestigationBusinessDetails", "insuranceInvestigationBusinessDriversDetails", "insuranceInvestigationBusinessAdditionalInformation", "additionalInformation"]));
                break;
            case orderTypes.PLL:
                populateInsuranceInvestigationLocateForms(specificOrderDetails);
                dispatch(updateSpecificOrderTypeDetailsProps(["insuranceInvestigationLocateDetails", "insuranceInvestigationLocateDriversDetails", "insuranceInvestigationLocateAdditionalInformation", "additionalInformation"]));
                break;
            case orderTypes.PLPAU:
                populateInsuranceInvestigationAutoUmbrellaForms(specificOrderDetails);
                dispatch(updateSpecificOrderTypeDetailsProps(["insuranceInvestigationPersonalAutoUmbrellaDetails", "insuranceInvestigationPersonalAutoUmbrellaDriversDetails", "insuranceInvestigationPersonalAutoUmbrellaAdditionalInformation", "additionalInformation"]));
                break;
            case orderTypes.PLPHR:
                populateInsuranceInvestigationHomeownersRentersForms(specificOrderDetails);
                dispatch(updateSpecificOrderTypeDetailsProps(["insuranceInvestigationPersonalHomeownersRentersDetails", "insuranceInvestigationPersonalHomeownersRentersAdditionalInformation", "additionalInformation"]));
                break;
            case orderTypes.SI:
                populateSceneInvestigationForms(specificOrderDetails);
                dispatch(updateSpecificOrderTypeDetailsProps(["sceneInvestigationDetails", "additionalInformation"]));
                break;
            case orderTypes.ST:
                populateSkipTraceForms(specificOrderDetails);
                dispatch(updateSpecificOrderTypeDetailsProps(["skipTraceDetails", "additionalInformation"]));
                break;
            case orderTypes.SERVE:
                populateSubpoenaProcessServingForms(specificOrderDetails);
                dispatch(updateSpecificOrderTypeDetailsProps(["subpoenaProcessServingDetails", "additionalInformation"]));
                break;
            case orderTypes.SWITRS:
                populateSwitrsForms(specificOrderDetails);
                dispatch(updateSpecificOrderTypeDetailsProps(["switrsDetails", "additionalInformation"]));
                break;
            case orderTypes.TCR:
                populateTrafficCollisionsReportRetrievalForms(specificOrderDetails);
                dispatch(updateSpecificOrderTypeDetailsProps(["trafficCollisionsReportRetrievalDetails", "additionalInformation"]));
                break;
            case orderTypes.DWS:
                populateWitnessDefendantStatementForms(specificOrderDetails);
                dispatch(updateSpecificOrderTypeDetailsProps(["witnessDefendantStatementDetails", "witnessDefendantStatementDefendantDetails", "witnessDefendantStatementWitnessDetails", "witnessDefendantStatementFaultInfo", "additionalInformation"]));
                break;
            // default:
        }
        populateAdditionalInformationForm(specificOrderDetails);
    };

    function convertTimeToISOString(timeString) {
        if (timeString.includes(':')) {
            // Split the time into hours, minutes, and AM/PM
            const [time, modifier] = timeString.toLowerCase().split(/(am|pm)/);
            let [hours, minutes] = time.split(':').map(Number);
        
            // Adjust hours based on AM/PM
            if (modifier === 'pm' && hours !== 12) {
                hours += 12;
            } else if (modifier === 'am' && hours === 12) {
                hours = 0;
            }
        
            // Create a new Date object with today's date and set the parsed hours and minutes
            const now = new Date();
            now.setHours(hours, minutes, 0, 0); // Set hours, minutes, seconds, and ms
        
            // Convert the date object to ISO format
            return now.toString();
        } 
        return '';
      }

    // Additional Information
    const populateAdditionalInformationForm = (specificOrderDetails) => {
        const initialValues = {
            additionalInformation: specificOrderDetails.additionalInformation || '',
            files: specificOrderDetails.files || [],
        };
        dispatch(updateActiveFormAdditionalInformation(initialValues));
    }

    // Asset Locate
    const populateAssetLocateForms = (specificOrderDetails) => {
        //Type
        const typeInitialValues = {
            assetLocateType: specificOrderDetails.assetLocateType || '',
        };
        dispatch(updateActiveFormAssetLocateType(typeInitialValues));

        // Details
        const detailsInitialValuesPerson = {
            firstName: specificOrderDetails.firstName || '',
            lastName: specificOrderDetails.lastName || '',
            address: specificOrderDetails.address || '',
            address2: specificOrderDetails.address2 || '',
            city: specificOrderDetails.city || '',
            stateProvince: specificOrderDetails.stateProvince || '',
            zip: specificOrderDetails.zip || '',
            country: specificOrderDetails.country || '',
            ssn: specificOrderDetails.ssn || '',
            dob: specificOrderDetails.dob || '',
        };
    
        const detailsInitialValuesBusiness = {
            businessName: specificOrderDetails.businessName || '',
            fein: specificOrderDetails.fein || '',
            address: specificOrderDetails.address || '',
            address2: specificOrderDetails.address2 || '',
            city: specificOrderDetails.city || '',
            stateProvince: specificOrderDetails.stateProvince || '',
            zip: specificOrderDetails.zip || '',
            country: specificOrderDetails.country || '',
            ceoPresidentName: specificOrderDetails.ceoPresidentName || '',
            ssn: specificOrderDetails.ssn || '',
        };
        const detailsInitialValues = specificOrderDetails.assetLocateType === "Subject/Target" ? detailsInitialValuesPerson : detailsInitialValuesBusiness;
        dispatch(updateActiveFormAssetLocateDetails(detailsInitialValues));

        // Request
        const requestInitialValues = {
            assetLocateRequest: specificOrderDetails.assetLocateRequest || [],
            stateProvinceRequested: specificOrderDetails.stateProvinceRequested || ''
        };
        dispatch(updateActiveFormAssetLocateRequest(requestInitialValues));
    };

    // Background Screening
    const populateBackgroundScreeningForms = (specificOrderDetails) => {
        // Details
        const detailsInitialValues = {
            firstName: specificOrderDetails.firstName || '',
            lastName: specificOrderDetails.lastName || '',
            emailPrimary: specificOrderDetails.emailPrimary || '',
            emailSecondary: specificOrderDetails.emailSecondary || '',
            phonePrimary: specificOrderDetails.phonePrimary || '',
            phoneSecondary: specificOrderDetails.phoneSecondary || '',
            address: specificOrderDetails.address || '',
            address2: specificOrderDetails.address2 || '',
            city: specificOrderDetails.city || '',
            stateProvince: specificOrderDetails.stateProvince || '',
            zip: specificOrderDetails.zip || '',
            country: specificOrderDetails.country || '',
            vin: specificOrderDetails.vin || '',
            licensePlate: specificOrderDetails.licensePlate || '',
            jobs: specificOrderDetails.jobs || '',
            dob: specificOrderDetails.dob || '',
            age: specificOrderDetails.age || '',
            informationType: specificOrderDetails.informationType || '',
            socialMedia: specificOrderDetails.socialMedia || '',
        };
        dispatch(updateActiveFormBackgroundScreeningDetails(detailsInitialValues));

        // Social Media
        const socialMediaInitialValues = specificOrderDetails.socialMedia === "Yes" ? {
            socialMediaFirstName: specificOrderDetails.socialMediaFirstName || specificOrderDetails.firstName || '',
            socialMediaLastName: specificOrderDetails.socialMediaLastName || specificOrderDetails.lastName || '',
            socialMediaEmail: specificOrderDetails.socialMediaEmail || specificOrderDetails.emailPrimary || '',
            socialMediaPhone: specificOrderDetails.socialMediaPhone || specificOrderDetails.phonePrimary || '',
            socialMediaAddress: specificOrderDetails.socialMediaAddress || specificOrderDetails.address || '',
            socialMediaAddress2: specificOrderDetails.socialMediaAddress2 || specificOrderDetails.address2 || '',
            socialMediaCity: specificOrderDetails.socialMediaCity || specificOrderDetails.city || '',
            socialMediaStateProvince: specificOrderDetails.socialMediaStateProvince || specificOrderDetails.stateProvince || '',
            socialMediaZip: specificOrderDetails.socialMediaZip || specificOrderDetails.zip || '',
            socialMediaCountry: specificOrderDetails.socialMediaCountry || specificOrderDetails.country || '',
            socialMediaLocations: specificOrderDetails.socialMediaLocations || '',
            socialMediaConnectionsAssociates: specificOrderDetails.socialMediaConnectionsAssociates || '',
            socialMediaConnectionsAssociatesLocations: specificOrderDetails.socialMediaConnectionsAssociatesLocations || '',
            socialMediaUsername: specificOrderDetails.socialMediaUsername || '',
            socialMediaVin: specificOrderDetails.socialMediaVin || specificOrderDetails.vin || '',
            socialMediaLicensePlate: specificOrderDetails.socialMediaLicensePlate || specificOrderDetails.licensePlate || '',
            socialMediaKeyword: specificOrderDetails.socialMediaKeyword || '',
            socialMediaJob: specificOrderDetails.socialMediaJob || specificOrderDetails.jobs || '',
            socialMediaDob: specificOrderDetails.socialMediaDob || specificOrderDetails.dob || '',
            socialMediaAge: specificOrderDetails.socialMediaAge || specificOrderDetails.age || '',
            socialMediaSchool: specificOrderDetails.socialMediaSchool || '',
            socialMediaDateOfIncident: specificOrderDetails.socialMediaDateOfIncident || '',
        } : {};
        dispatch(updateActiveFormBackgroundScreeningSocialMedia(socialMediaInitialValues));
    };

    // Business Due Diligence
    const populateBusinessDueDiligenceForms = (specificOrderDetails) => {
        const initialValues = {
            businessName: specificOrderDetails.businessName || '',
            ownersName: specificOrderDetails.ownersName || '',
            businessAddress: specificOrderDetails.businessAddress || '',
            businessAddress2: specificOrderDetails.businessAddress2 || '',
            city: specificOrderDetails.city || '',
            stateProvince: specificOrderDetails.stateProvince || '',
            zip: specificOrderDetails.zip || '',
            country: specificOrderDetails.country || '',
        };
        dispatch(updateActiveFormBusinessDueDiligenceDetails(initialValues));
    }

    // DMV
    const populateDmvForms = (specificOrderDetails) => {
        // Details
        const detailsInitialValues = {
            firstName: specificOrderDetails.firstName || '',
            lastName: specificOrderDetails.lastName || '',
            email: specificOrderDetails.email || '',
            phone: specificOrderDetails.phone || '',
            lastKnownAddress1: specificOrderDetails.lastKnownAddress1 || '',
            lastKnownAddress2: specificOrderDetails.lastKnownAddress2 || '',
            city: specificOrderDetails.city || '',
            stateProvince: specificOrderDetails.stateProvince || '',
            zip: specificOrderDetails.zip || '',
            country: specificOrderDetails.country || '',
            dob: specificOrderDetails.dob || '',
            age: specificOrderDetails.age || '',
            vin: specificOrderDetails.vin || '',
            licensePlate: specificOrderDetails.licensePlate || '',
        };
        dispatch(updateActiveFormDMVDetails(detailsInitialValues));
    };

    // Insurance Claim History
    const populateInsuranceClaimHistoryForms = (specificOrderDetails) => {
        // Details
        const detailsInitialValues = {
            insuranceClaimHistoryDetails: specificOrderDetails.insuranceClaimHistoryDetails || '',
        };
        dispatch(updateActiveFormInsuranceClaimHistoryDetails(detailsInitialValues));
        
        // Subject
        const subjectInitialValues = {
            firstName: specificOrderDetails.insuranceClaimHistoryDetails === 'Yes' ? clientInfo.firstNameClient : (specificOrderDetails.firstName || ''),
            lastName: specificOrderDetails.insuranceClaimHistoryDetails === 'Yes' ? clientInfo.lastNameClient : (specificOrderDetails.lastName || ''),
            email: specificOrderDetails.email || '',
            phone: specificOrderDetails.phone || '',
            address: specificOrderDetails.address || '',
            address2: specificOrderDetails.address2 || '',
            city: specificOrderDetails.city || '',
            stateProvince: specificOrderDetails.stateProvince || '',
            zip: specificOrderDetails.zip || '',
            country: specificOrderDetails.country || '',
            dob: specificOrderDetails.dob || '',
            ssn: specificOrderDetails.ssn || '',
            vin: specificOrderDetails.vin || '',
            licensePlate: specificOrderDetails.licensePlate || '',
        };
        dispatch(updateActiveFormInsuranceClaimHistorySubject(subjectInitialValues));
    };

    // Insurance Investigation - Business
    const populateInsuranceInvestigationBusinessForms = (specificOrderDetails) => {
        // Insured's Details
        const insuredInitialValues = {
            insuredType: specificOrderDetails.insuredType || '',
            dateOfLoss: specificOrderDetails.dateOfLoss || '',
            insuredName: specificOrderDetails.insuredName || '',
            insuredAddress: specificOrderDetails.insuredAddress || '',
            insuredAddress2: specificOrderDetails.insuredAddress2 || '',
            insuredCity: specificOrderDetails.insuredCity || '',
            insuredStateProvince: specificOrderDetails.insuredStateProvince || '',
            insuredZip: specificOrderDetails.insuredZip || '',
            insuredCountry: specificOrderDetails.insuredCountry || '',
            insuredDob: specificOrderDetails.insuredDob || '',
            insuredSsn: specificOrderDetails.insuredSsn || '',
            insuredVin: specificOrderDetails.insuredVin || '',
            insuredLicensePlate: specificOrderDetails.insuredLicensePlate || '',
            insuredLicenseNumber: specificOrderDetails.insuredLicenseNumber || '',
            ownersName: specificOrderDetails.ownersName || '',
            ownersAddress: specificOrderDetails.ownersAddress || '',
            ownersAddress2: specificOrderDetails.ownersAddress2 || '',
            ownersCity: specificOrderDetails.ownersCity || '',
            ownersStateProvince: specificOrderDetails.ownersStateProvince || '',
            ownersZip: specificOrderDetails.ownersZip || '',
            ownersCountry: specificOrderDetails.ownersCountry || '',
            ownerIsDriver: specificOrderDetails.ownerIsDriver || '',
            locateAddress: specificOrderDetails.locateAddress || '',
            locateAddress2: specificOrderDetails.locateAddress2 || '',
            locateCity: specificOrderDetails.locateCity || '',
            locateStateProvince: specificOrderDetails.locateStateProvince || '',
            locateZip: specificOrderDetails.locateZip || '',
            locateCountry: specificOrderDetails.locateCountry || ''
        };
        dispatch(updateActiveFormInsuranceInvestigationBusinessDetails(insuredInitialValues));

        // Driver's Details
        const driverInitialValues = {
            driversName: specificOrderDetails.ownerIsDriver === 'Yes' ? specificOrderDetails.ownersName : (specificOrderDetails.driversName || ''),
            address: specificOrderDetails.ownerIsDriver === 'Yes' ? specificOrderDetails.ownersAddress : (specificOrderDetails.address || ''),
            address2: specificOrderDetails.ownerIsDriver === 'Yes' ? specificOrderDetails.ownersAddress2 : (specificOrderDetails.address2 || ''),
            city: specificOrderDetails.ownerIsDriver === 'Yes' ? specificOrderDetails.ownersCity : (specificOrderDetails.city || ''),
            stateProvince: specificOrderDetails.ownerIsDriver === 'Yes' ? specificOrderDetails.ownersStateProvince : (specificOrderDetails.stateProvince || ''),
            zip: specificOrderDetails.ownerIsDriver === 'Yes' ? specificOrderDetails.ownersZip : (specificOrderDetails.zip || ''),
            country: specificOrderDetails.ownerIsDriver === 'Yes' ? specificOrderDetails.ownersCountry : (specificOrderDetails.country || ''),
            dob: specificOrderDetails.dob || '',
            driversLicensePlate: specificOrderDetails.driversLicensePlate || '',
            driversLicenseNumber: specificOrderDetails.driversLicenseNumber || '',
            driversInsuranceCompany: specificOrderDetails.driversInsuranceCompany || '',
            policy: specificOrderDetails.policy || '',
            claim: specificOrderDetails.claim || '',
        };
        dispatch(updateActiveFormInsuranceInvestigationBusinessDriversDetails(driverInitialValues));
        
        // Additional Information
        const additionalInfoInitialValues = {
            letterOfAcknowledgement: specificOrderDetails.letterOfAcknowledgement || '',
            defendantProofOfInsuranceCard: specificOrderDetails.defendantProofOfInsuranceCard || '',
            defendantDriversLicense: specificOrderDetails.defendantDriversLicense || '',
            trafficCollisionReport: specificOrderDetails.trafficCollisionReport || '',
        };
        dispatch(updateActiveFormInsuranceInvestigationBusinessAdditionalInformation(additionalInfoInitialValues));
    };

    // Insurance Investigation - Locate
    const populateInsuranceInvestigationLocateForms = (specificOrderDetails) => {
        // Insured's Details
        const insuredInitialValues = {
            insuredType: specificOrderDetails.insuredType || '',
            policyLimits: specificOrderDetails.policyLimits || '',
            dateOfLoss: specificOrderDetails.dateOfLoss || '',
            insuredName: specificOrderDetails.insuredName || '',
            insuredAddress: specificOrderDetails.insuredAddress || '',
            insuredAddress2: specificOrderDetails.insuredAddress2 || '',
            insuredCity: specificOrderDetails.insuredCity || '',
            insuredStateProvince: specificOrderDetails.insuredStateProvince || '',
            insuredZip: specificOrderDetails.insuredZip || '',
            insuredCountry: specificOrderDetails.insuredCountry || '',
            insuredDob: specificOrderDetails.insuredDob || '',
            insuredSsn: specificOrderDetails.insuredSsn || '',
            insuredVin: specificOrderDetails.insuredVin || '',
            insuredLicensePlate: specificOrderDetails.insuredLicensePlate || '',
            registeredOwnersName: specificOrderDetails.registeredOwnersName || '',
            registeredOwnersAddress: specificOrderDetails.registeredOwnersAddress || '',
            registeredOwnersAddress2: specificOrderDetails.registeredOwnersAddress2 || '',
            registeredOwnersCity: specificOrderDetails.registeredOwnersCity || '',
            registeredOwnersStateProvince: specificOrderDetails.registeredOwnersStateProvince || '',
            registeredOwnersZip: specificOrderDetails.registeredOwnersZip || '',
            registeredOwnersCountry: specificOrderDetails.registeredOwnersCountry || '',
            registeredOwnerIsDriver: specificOrderDetails.registeredOwnerIsDriver || '',
            locateAddress: specificOrderDetails.locateAddress || '',
            locateAddress2: specificOrderDetails.locateAddress2 || '',
            locateCity: specificOrderDetails.locateCity || '',
            locateStateProvince: specificOrderDetails.locateStateProvince || '',
            locateZip: specificOrderDetails.locateZip || '',
            locateCountry: specificOrderDetails.locateCountry || ''
        };
        dispatch(updateActiveFormInsuranceInvestigationLocateDetails(insuredInitialValues));

        // Driver's Details
        const driverInitialValues = {
            driversName: specificOrderDetails.registeredOwnerIsDriver === 'Yes' ? specificOrderDetails.registeredOwnersName : (specificOrderDetails.driversName || ''),
            address: specificOrderDetails.registeredOwnerIsDriver === 'Yes' ? specificOrderDetails.registeredOwnersAddress : (specificOrderDetails.address || ''),
            address2: specificOrderDetails.registeredOwnerIsDriver === 'Yes' ? specificOrderDetails.registeredOwnersAddress2 : (specificOrderDetails.address2 || ''),
            city: specificOrderDetails.registeredOwnerIsDriver === 'Yes' ? specificOrderDetails.registeredOwnersCity : (specificOrderDetails.city || ''),
            stateProvince: specificOrderDetails.registeredOwnerIsDriver === 'Yes' ? specificOrderDetails.registeredOwnersStateProvince : (specificOrderDetails.stateProvince || ''),
            zip: specificOrderDetails.registeredOwnerIsDriver === 'Yes' ? specificOrderDetails.registeredOwnersZip : (specificOrderDetails.zip || ''),
            country: specificOrderDetails.registeredOwnerIsDriver === 'Yes' ? specificOrderDetails.registeredOwnersCountry : (specificOrderDetails.country || ''),
            dob: specificOrderDetails.dob || '',
            driversLicensePlate: specificOrderDetails.driversLicensePlate || '',
            driversLicenseNumber: specificOrderDetails.driversLicenseNumber || '',
            driversInsuranceCompany: specificOrderDetails.driversInsuranceCompany || '',
            policy: specificOrderDetails.policy || '',
            claim: specificOrderDetails.claim || '',
        };
        dispatch(updateActiveFormInsuranceInvestigationLocateDriversDetails(driverInitialValues));
        
        // Additional Information
        const additionalInfoInitialValues = {
            letterOfAcknowledgement: specificOrderDetails.letterOfAcknowledgement || '',
            defendantProofOfInsuranceCard: specificOrderDetails.defendantProofOfInsuranceCard || '',
            defendantDriversLicense: specificOrderDetails.defendantDriversLicense || '',
            trafficCollisionReport: specificOrderDetails.trafficCollisionReport || '',
        };
        dispatch(updateActiveFormInsuranceInvestigationLocateAdditionalInformation(additionalInfoInitialValues));

    };

    // Insurance Investigation - Personal - Auto Umbrella
    const populateInsuranceInvestigationAutoUmbrellaForms = (specificOrderDetails) => {
        // Insured's Details
        const insuredInitialValues = {
            insuredType: specificOrderDetails.insuredType || '',
            dateOfLoss: specificOrderDetails.dateOfLoss || '',
            insuredName: specificOrderDetails.insuredName || '',
            insuredAddress: specificOrderDetails.insuredAddress || '',
            insuredAddress2: specificOrderDetails.insuredAddress2 || '',
            insuredCity: specificOrderDetails.insuredCity || '',
            insuredStateProvince: specificOrderDetails.insuredStateProvince || '',
            insuredZip: specificOrderDetails.insuredZip || '',
            insuredCountry: specificOrderDetails.insuredCountry || '',
            insuredDob: specificOrderDetails.insuredDob || '',
            insuredSsn: specificOrderDetails.insuredSsn || '',
            insuredVin: specificOrderDetails.insuredVin || '',
            insuredLicensePlate: specificOrderDetails.insuredLicensePlate || '',
            ownersName: specificOrderDetails.ownersName || '',
            ownersAddress: specificOrderDetails.ownersAddress || '',
            ownersAddress2: specificOrderDetails.ownersAddress2 || '',
            ownersCity: specificOrderDetails.ownersCity || '',
            ownersStateProvince: specificOrderDetails.ownersStateProvince || '',
            ownersZip: specificOrderDetails.ownersZip || '',
            ownersCountry: specificOrderDetails.ownersCountry || '',
            ownerIsDriver: specificOrderDetails.ownerIsDriver || '',
            locateAddress: specificOrderDetails.locateAddress || '',
            locateAddress2: specificOrderDetails.locateAddress2 || '',
            locateCity: specificOrderDetails.locateCity || '',
            locateStateProvince: specificOrderDetails.locateStateProvince || '',
            locateZip: specificOrderDetails.locateZip || '',
            locateCountry: specificOrderDetails.locateCountry || ''
        };
        dispatch(updateActiveFormInsuranceInvestigationPersonalAutoUmbrellaDetails(insuredInitialValues));
        
        // Driver's Details
        const driverInitialValues = {
            driversName: specificOrderDetails.ownerIsDriver === 'Yes' ? specificOrderDetails.ownersName : (specificOrderDetails.driversName || ''),
            address: specificOrderDetails.ownerIsDriver === 'Yes' ? specificOrderDetails.ownersAddress : (specificOrderDetails.address || ''),
            address2: specificOrderDetails.ownerIsDriver === 'Yes' ? specificOrderDetails.ownersAddress2 : (specificOrderDetails.address2 || ''),
            city: specificOrderDetails.ownerIsDriver === 'Yes' ? specificOrderDetails.ownersCity : (specificOrderDetails.city || ''),
            stateProvince: specificOrderDetails.ownerIsDriver === 'Yes' ? specificOrderDetails.ownersStateProvince : (specificOrderDetails.stateProvince || ''),
            zip: specificOrderDetails.ownerIsDriver === 'Yes' ? specificOrderDetails.ownersZip : (specificOrderDetails.zip || ''),
            country: specificOrderDetails.ownerIsDriver === 'Yes' ? specificOrderDetails.ownersCountry : (specificOrderDetails.country || ''),
            dob: specificOrderDetails.dob || '',
            driversLicensePlate: specificOrderDetails.driversLicensePlate || '',
            driversInsuranceCompany: specificOrderDetails.driversInsuranceCompany || '',
            policy: specificOrderDetails.policy || '',
            claim: specificOrderDetails.claim || '',
        };
        dispatch(updateActiveFormInsuranceInvestigationPersonalAutoUmbrellaDriversDetails(driverInitialValues));
        
        // Additional Information
        const additionalInfoInitialValues = {
            letterOfAcknowledgement: specificOrderDetails.letterOfAcknowledgement || '',
            defendantProofOfInsuranceCard: specificOrderDetails.defendantProofOfInsuranceCard || '',
            defendantDriversLicense: specificOrderDetails.defendantDriversLicense || '',
            trafficCollisionReport: specificOrderDetails.trafficCollisionReport || '',
        };
        dispatch(updateActiveFormInsuranceInvestigationPersonalAutoUmbrellaAdditionalInformation(additionalInfoInitialValues));

    };

    // Insurance Investigation - Personal - Homeowners Renters
    const populateInsuranceInvestigationHomeownersRentersForms = (specificOrderDetails) => {
        // Insured's Details
        const initialValues = {
            insuredType: specificOrderDetails.insuredType || '',
            dateOfLoss: specificOrderDetails.dateOfLoss || '',
            insuredName: specificOrderDetails.insuredName || '',
            insuredAddress: specificOrderDetails.insuredAddress || '',
            insuredAddress2: specificOrderDetails.insuredAddress2 || '',
            insuredCity: specificOrderDetails.insuredCity || '',
            insuredStateProvince: specificOrderDetails.insuredStateProvince || '',
            insuredZip: specificOrderDetails.insuredZip || '',
            insuredCountry: specificOrderDetails.insuredCountry || '',
            insuredDob: specificOrderDetails.insuredDob || '',
            insuredSsn: specificOrderDetails.insuredSsn || '',
            homeownerRentersName: specificOrderDetails.homeownerRentersName || '',
            lossAddress: specificOrderDetails.lossAddress || '',
            lossAddress2: specificOrderDetails.lossAddress2 || '',
            lossCity: specificOrderDetails.lossCity || '',
            lossState: specificOrderDetails.lossState || '',
            lossZip: specificOrderDetails.lossZip || '',
            lossCountry: specificOrderDetails.lossCountry || '',
            insuranceCompany: specificOrderDetails.insuranceCompany || '',
            policy: specificOrderDetails.policy || '',
            claim: specificOrderDetails.claim || '',
            locateAddress: specificOrderDetails.locateAddress || '',
            locateAddress2: specificOrderDetails.locateAddress2 || '',
            locateCity: specificOrderDetails.locateCity || '',
            locateStateProvince: specificOrderDetails.locateStateProvince || '',
            locateZip: specificOrderDetails.locateZip || '',
            locateCountry: specificOrderDetails.locateCountry || ''
        };
        dispatch(updateActiveFormInsuranceInvestigationPersonalHomeownersRentersDetails(initialValues));
        
        // Additional Information
        const additionalInfoInitialValues = {
            letterOfAcknowledgement: specificOrderDetails.letterOfAcknowledgement || '',
            defendantProofOfInsuranceCard: specificOrderDetails.defendantProofOfInsuranceCard || '',
            defendantDriversLicense: specificOrderDetails.defendantDriversLicense || '',
            trafficCollisionReport: specificOrderDetails.trafficCollisionReport || '',
        };
        dispatch(updateActiveFormInsuranceInvestigationPersonalHomeownersRentersAdditionalInformation(additionalInfoInitialValues));

    };

    // Scene Investigation
    const populateSceneInvestigationForms = (specificOrderDetails) => {
        const initialValues = {
            dateOfLoss: specificOrderDetails.dateOfLoss || '',
            timeOfLoss: convertTimeToISOString(specificOrderDetails.timeOfLoss) || '',
            surveillanceType: specificOrderDetails.surveillanceType || '',
            investigationSubject: specificOrderDetails.investigationSubject || '',
            investigationLocation: specificOrderDetails.investigationLocation || '',
            subjectVehicleDescription: specificOrderDetails.subjectVehicleDescription || '',
            subjectVehiclelicensePlate: specificOrderDetails.subjectVehiclelicensePlate || '',
            factsOfLoss: specificOrderDetails.factsOfLoss || '',
        };
        dispatch(updateActiveFormSceneInvestigationDetails(initialValues));
    };

    // Skip Trace
    const populateSkipTraceForms = (specificOrderDetails) => {
        const initialValues = {
            firstName: specificOrderDetails.firstName || '',
            lastName: specificOrderDetails.lastName || '',
            email: specificOrderDetails.email || '',
            phone: specificOrderDetails.phone || '',
            lastKnownAddress1Line1: specificOrderDetails.lastKnownAddress1Line1 || '',
            lastKnownAddress1Line2: specificOrderDetails.lastKnownAddress1Line2 || '',
            lastKnownAddress1City: specificOrderDetails.lastKnownAddress1City || '',
            lastKnownAddress1StateProvince: specificOrderDetails.lastKnownAddress1StateProvince || '',
            lastKnownAddress1Zip: specificOrderDetails.lastKnownAddress1Zip || '',
            lastKnownAddress1Country: specificOrderDetails.lastKnownAddress1Country || '',
            lastKnownAddress2Line1: specificOrderDetails.lastKnownAddress2Line1 || '',
            lastKnownAddress2Line2: specificOrderDetails.lastKnownAddress2Line2 || '',
            lastKnownAddress2City: specificOrderDetails.lastKnownAddress2City || '',
            lastKnownAddress2StateProvince: specificOrderDetails.lastKnownAddress2StateProvince || '',
            lastKnownAddress2Zip: specificOrderDetails.lastKnownAddress2Zip || '',
            lastKnownAddress2Country: specificOrderDetails.lastKnownAddress2Country || '',
            dob: specificOrderDetails.dob || '',
            age: specificOrderDetails.age || '',
            vin: specificOrderDetails.vin || '',
            licensePlate: specificOrderDetails.licensePlate || '',
        };
        dispatch(updateActiveFormSkipTraceDetails(initialValues));
    };

    // Subpoena Process Serving
    const populateSubpoenaProcessServingForms = (specificOrderDetails) => {
        const initialValues = {
            firstName: specificOrderDetails.firstName || '',
            lastName: specificOrderDetails.lastName || '',
            email: specificOrderDetails.email || '',
            phone: specificOrderDetails.phone || '',
            address1: specificOrderDetails.address1 || '',
            address2: specificOrderDetails.address2 || '',
            city: specificOrderDetails.city || '',
            stateProvince: specificOrderDetails.stateProvince || '',
            zip: specificOrderDetails.zip || '',
            country: specificOrderDetails.country || '',
            typeOfService: specificOrderDetails.typeOfService || '',
            lastDayToComplete: specificOrderDetails.lastDayToComplete || '',
            vin: specificOrderDetails.vin || '',
            licensePlate: specificOrderDetails.licensePlate || '',
        };
        dispatch(updateActiveFormSubpoenaProcessServingDetails(initialValues));
    };
    
    // SWITRS
    const populateSwitrsForms = (specificOrderDetails) => {
        const initialValues = {
            location: specificOrderDetails.location || '',
            files: specificOrderDetails.files || [],
        };
        dispatch(updateActiveFormSWITRSDetails(initialValues));
    };

    // Traffic Collisions Report Retrieval
    const populateTrafficCollisionsReportRetrievalForms = (specificOrderDetails) => {
        const initialValues = {
            policeDept: specificOrderDetails.policeDept || '',
            dateOfLoss: specificOrderDetails.dateOfLoss || '',
            timeOfLoss: convertTimeToISOString(specificOrderDetails.timeOfLoss) || '',
            clientDob: specificOrderDetails.clientDob || '',
            clientDriversLicenseNumber: specificOrderDetails.clientDriversLicenseNumber || '',
            reportNumber: specificOrderDetails.reportNumber || '',
            lossLocation: specificOrderDetails.lossLocation || '',
            City: specificOrderDetails.City || '',
            vehicle1: specificOrderDetails.vehicle1 || '',
            licensePlate1: specificOrderDetails.licensePlate1 || '',
            vehicle2: specificOrderDetails.vehicle2 || '',
            licensePlate2: specificOrderDetails.licensePlate2 || '',
            vehicle3: specificOrderDetails.vehicle3 || '',
            licensePlate3: specificOrderDetails.licensePlate3 || '',
            files: specificOrderDetails.files || [],
        };
        dispatch(updateTrafficCollisionsReportRetrievalDetails(initialValues));
    };

    // Witness Defendant Statement
    const populateWitnessDefendantStatementForms = (specificOrderDetails) => {
        // Details
        const detailsInitialValues = {
            dateOfLoss: specificOrderDetails.dateOfLoss || '',
            timeOfLoss: convertTimeToISOString(specificOrderDetails.timeOfLoss) || '',
            locationOfLoss: specificOrderDetails.locationOfLoss || '',
            factsOfLoss: specificOrderDetails.factsOfLoss || '',
            specificQuestions: specificOrderDetails.specificQuestions || '',
            directionOfTravel: specificOrderDetails.directionOfTravel || '',
            streetOfTravel: specificOrderDetails.streetOfTravel || '',
            vehicleDescription: specificOrderDetails.vehicleDescription || '',
            pedestrianIdentifiers: specificOrderDetails.pedestrianIdentifiers || '',
            statementType: specificOrderDetails.statementType || '',
        };
        dispatch(updateWitnessDefendantStatementDetails(detailsInitialValues));

        // Defendant Info
        const defendantsObjectInitialValue = {
            firstName: '',
            lastName: '',
            dateOfBirth: '',
            phone: '',
            address1: '',
            address2: '',
            city: '',
            stateProvince: '',
            zip: '',
            county: '',
            directionOfTravel: '',
            streetOfTravel: '',
            defendantVehicleDescription: '',
        };

        const defendantsInitialValue = {
            defendants: specificOrderDetails.defendants || [defendantsObjectInitialValue],
        };
        dispatch(updateWitnessDefendantStatementDefendantDetails(defendantsInitialValue));
        
        // Witness Info
        const witnessObjectInitialValue = {
            firstName: '',
            lastName: '',
            dateOfBirth: '',
            phone: '',
            address1: '',
            address2: '',
            city: '',
            stateProvince: '',
            zip: '',
            county: '',
        };

        const witnessInitialValue = {
            witnesses: specificOrderDetails.witnesses || [witnessObjectInitialValue],
        };
        dispatch(updateWitnessDefendantStatementWitnessDetails(witnessInitialValue));
        
        // Fault Info
        const faultInfoInitialValues = {
            acceptedLiability: specificOrderDetails.acceptedLiability || '',
            files: specificOrderDetails.files || [],
        };
        dispatch(updateWitnessDefendantStatementFaultInfo(faultInfoInitialValues));
    };


    return { populateFormData };
}


